import { Pipe, PipeTransform } from '@angular/core'
import { DatePipe } from '@angular/common'
import { convertDateToLocaleTimeWithTimezone } from '../../shared/functions/date-time'

// Return Format "8:00 AM CDT on Sept 15, 2018"
@Pipe({ name: 'floLiveDateTime' })
export class FloLiveDateTimePipe implements PipeTransform {
  constructor(private dp: DatePipe) {}

  public readonly transform = (str?: string, isTbd?: boolean) =>
    str
      ? `${isTbd ? 'TBD' : convertDateToLocaleTimeWithTimezone(new Date(str))} on ${this.dp.transform(
          str,
          'mediumDate'
        )}`
      : ''
}
